import React from 'react';

import Button from '../../../Button/Button';
import CustomText from '../../../Typography/CustomText/CustomText';

const ClearSelection = ({ selected, data, clearSelect }) => (
  <div>
    <CustomText color="gray">
      {selected.length} of {data.length} items selected
    </CustomText>
    <Button onClick={clearSelect} type="link">
      Clear selection
    </Button>
  </div>
);

export default ClearSelection;
